import React, { useEffect, useRef, KeyboardEvent } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Input from '@mui/material/Input';
import { SxProps } from '@mui/system';

const useStyles = makeStyles(
  (theme: Theme) => ({
    wrapper: {
      width: 'calc( 100vw - ' + theme.spacing(4) + ')', // Mobile (Default)
      [theme.breakpoints.up('sm')]: {
        width: 'calc( 100vw - ' + theme.spacing(6) + ' - 125px - 24px - 80px - 8px - 16px)',
      },
      [theme.breakpoints.up('md')]: {
        width: 'calc( 100vw - ' + theme.spacing(6) + ' - 125px - 24px - 80px - 8px)',
      },
      [theme.breakpoints.up('lg')]: {
        maxWidth: 840, // TODO - Figure out centering...
      },
    },
    wrapperInner: {
      backgroundColor: '#323232',
      width: '100%',
      display: 'flex',
      flexFlow: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: 50,
      borderRadius: 10,
    },
  }),
  { name: 'AltSearchInput' },
);

interface AltSearchInputProps {
  active: boolean;
  query?: string;
  onIconClick?: () => void;
  onClose?: () => void;
  onQueryChange: (ev: any, val: string) => void;
  sx?: SxProps<Theme>;
}

const AltSearchInput: React.FC<AltSearchInputProps> = ({ active, query, onIconClick, onQueryChange, onClose }) => {
  const classes = useStyles();
  const ref = useRef<HTMLInputElement>();
  // Get focus without scrolling...
  useEffect(() => {
    if (active && ref && ref.current) {
      const applyFocus = () => {
        if (ref && ref.current) {
          ref.current.focus({
            preventScroll: true,
          });
        }
      };
      const timeout = setTimeout(() => {
        applyFocus();
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [active, ref]);

  const handleClear = () => {
    onClose && onClose();
  };

  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      ref?.current?.blur();
    }
  };

  return (
    <>
      <Collapse
        classes={{
          wrapper: classes.wrapper,
          wrapperInner: classes.wrapperInner,
        }}
        orientation="horizontal"
        in={active}
        collapsedSize={0}
        timeout={{
          appear: 250,
          enter: 250,
          exit: 0,
        }}
      >
        <Input
          // search input
          inputRef={ref}
          value={query}
          onChange={(ev) => onQueryChange(ev, ev.target.value)}
          margin="none"
          disableUnderline
          fullWidth
          placeholder="Search for gift cards"
          onKeyDown={onKeyDown}
          startAdornment={
            <IconButton onClick={onIconClick} size="large">
              <SearchIcon />
            </IconButton>
          }
          endAdornment={
            <IconButton onClick={handleClear} size="large">
              <CloseIcon />
            </IconButton>
          }
        />
      </Collapse>
    </>
  );
};

export default AltSearchInput;
